import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./AllMutualFundWelcome.css";
function AllMutualFundWelcome() {
  return (
    <>
      <section className="all-Mutual-welcome">
        <Container>
          <Row>
            <Col md={12}>
              <h1>All Mutual Fund</h1>
             
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default AllMutualFundWelcome;
